import React, { useEffect, useState } from "react";
import { Container, Title } from "./styles";
import { CSidebar } from "../../../../components/Sidebar";
import Header from "../../../../components/Header";
import MainTable from "../../../../components/MainTable";
import api from "../../../../services/api";
import { useAuth } from "../../../../hooks/auth";
import getPermission from "../../../../utils/getPermission";

const GerenciaRh: React.FC = () => {
  const [gerencias, setGerencias] = useState([]);
  const [searchValue, setSearchValue] = useState("");

  const {login} = useAuth();
  const rhPermission = getPermission(login,"Recursos Humanos") ?? '';

  useEffect(() => {
    const delayedSearch = setTimeout(() => {
      api
        .get(`administrations?busca_rapida=${searchValue}`)
        .then((response) => {
          setGerencias(response.data);
        })
        .catch((error) => console.log(error));
    }, 500);

    return () => clearTimeout(delayedSearch);
  }, [searchValue]);

  const handlePagination = (goBack = false) => {
    const page = goBack ? -1 : 1;

    api
      .get(`administrations?page=${gerencias.pagination.current_page + page}`)
      .then((response) => {
        setGerencias(response.data);
      })
      .catch((error) => console.log(error));
  };

  const columnData = [
    { headerName: "Código", field: "id" },
    { headerName: "Gerencia", field: "nome" },
    { headerName: "Situação", field: "ativo" },
  ];

  const organizeData = (data: any) => {
    if (typeof data === "object") {
      data = data.map((d: any) => ({
        id: d.id,
        nome: d.nome,
        ativo: d.ativo,
      }));
    }

    return data;
  };

  return (
    <div style={{ display: "flex", height: "100%" }}>
      <div style={{ height: "100%" }}>
        <CSidebar />
      </div>
      <div style={{ display: "block", width: "100%" }}>
        <Header />
        <Title color="#333">
          <span>Gestão de gerência</span>
        </Title>
        <Container color="#FFF">
          <MainTable
            onSearchChange={setSearchValue}
            data={organizeData(gerencias.data)}
            pagination={gerencias.pagination}
            permission={rhPermission}
            hideCreate={rhPermission == "Visitante"}
            handlePagination={handlePagination}
            hideFilter={true}
            isMaxWidthCell
            registerLink="/rh/cadastros/gerencia/cadastrar"
            columns={columnData}
            dropdown={{
              view: { linkTo: "/rh/cadastros/gerencia/visualizar" },
              editar: { linkTo: "/rh/cadastros/gerencia/editar" },
              desativar: { linkTo: "administrations" },
            }}
          />
        </Container>
      </div>
    </div>
  );
};

export default GerenciaRh;
